import UserActions from '@/store/actions/profile'
import AuthService from '@/services/AuthService'
import Vue from 'vue'
import AuthActions from '@/store/actions/auth'

const state = {
  groups: [],
  username: '',
  firstName: '',
  lastName: '',
  email: '',
  profileLoaded: false,
};

const getters = {
  getGroups: state => state.groups,
  getUsername: state => state.username,
  getFirstName: state => state.firstName,
  getLastName: state => state.lastName,
  getEmail: state => state.email,
  getProfileLoaded: state => state.profileLoaded,
}

const actions = {
  [UserActions.USER_PROFILE_REQUEST]: ({commit, dispatch}) => {
    AuthService.getUserProfile()
        .then(resp => {
            commit(UserActions.USER_PROFILE_SUCCESS, resp)
        })
        .catch(resp => {
          //TODO: Handle error getting groups
          commit(UserActions.USER_PROFILE_ERROR);
        })
  },
};

const mutations = {
  [UserActions.USER_PROFILE_SUCCESS]: (state, resp) => {
    Vue.set(state, 'groups', resp.data.userGroups);
    Vue.set(state, 'username', resp.data.username);
    Vue.set(state, 'firstName', resp.data.firstName);
    Vue.set(state, 'lastName', resp.data.lastName);
    Vue.set(state, 'email', resp.data.email.toLowerCase());
    Vue.set(state, 'profileLoaded', true);
  },
  [UserActions.USER_PROFILE_ERROR]: (state, resp) => {
    Vue.set(state, 'groups', '');
    Vue.set(state, 'username', '');
    Vue.set(state, 'firstName', '');
    Vue.set(state, 'lastName', '');
    Vue.set(state, 'email', '');
    Vue.set(state, 'profileLoaded', true);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
}
